import { FindTenantForm } from './Login';

export default function FindTenantPage() {
  return <FindTenantForm />;
}
